import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { IonButton, IonText } from '@ionic/react';

const AuthStatusBar: React.FC = () => {
  const { isAuthenticated, user, loginWithRedirect, logout, isLoading } = useAuth0();

  if (isLoading) {
    return <IonText>Verificando autenticação...</IonText>;
  }

  return (
    <div style={{ padding: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {isAuthenticated ? (
        <>
          <IonText>
            👋 Olá, {user?.name || 'usuário'}
          </IonText>
          <IonButton
            size="small"
            color="danger"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Logout
          </IonButton>
        </>
      ) : (
        <IonButton size="small" onClick={() => loginWithRedirect()}>
          Login
        </IonButton>
      )}
    </div>
  );
};

export default AuthStatusBar;
